/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Step_FrontInputs */

const en_us2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 of 2 · front`)
};

const pt_br2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 de 2 · frente`)
};

const es_419_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 de 2 · frente`)
};

const pt_pt2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 de 2 · frente`)
};

const fr_fr2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 sur 2 · face`)
};

const de_de2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 von 2 · vorne`)
};

const it_it2_body_assessment_capture_step_front = /** @type {(inputs: Body_Assessment_Capture_Step_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 di 2 · fronte`)
};

/**
* | output |
* | --- |
* | "1 of 2 · front" |
*
* @param {Body_Assessment_Capture_Step_FrontInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_step_front = /** @type {((inputs?: Body_Assessment_Capture_Step_FrontInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Step_FrontInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_step_front(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_step_front(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_step_front(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_step_front(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_step_front(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_step_front(inputs)
	return en_us2_body_assessment_capture_step_front(inputs)
});
export { body_assessment_capture_step_front as "body-assessment.capture_step_front" }